module.exports = __webpack_public_path__ + "180475ce83f310498fd26ebb304c5ce6.MP3";